import { getCookie } from "./getCookie";

// This function sets the authentication token in the browser's cookie storage
// It ensures the token is accessible for subsequent API requests and user sessions.

const setCookie = (name, shop_id, token) => {
    const currentCookie = getCookie(name);
    const date = new Date();
    date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000);
    const expiredDate = date.toUTCString();
    if (currentCookie) {
        let cookieObj = JSON.parse(currentCookie);

        cookieObj[shop_id] = token;
        document.cookie = `${name}=${JSON.stringify(
            cookieObj
        )};expires=${expiredDate}; path=/; SameSite=None; Secure`;
    } else {
        const newCookieObj = {
            [shop_id]: token,
        };
        document.cookie = `${name}=${JSON.stringify(
            newCookieObj
        )};expires=${expiredDate}; path=/; SameSite=None; Secure`;
    }
};

export default setCookie;
